import React from 'react';

interface TooltipProps {
  content: React.ReactNode;
  className?: string;
}

export const Tooltip = ({ content, className = "" }: TooltipProps) => {
  return (
    <div className="relative inline-block group">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`h-4 w-4 text-gray-400 dark:text-white/50 group-hover:text-gray-600 dark:group-hover:text-white cursor-pointer transition-colors ${className}`}
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4" />
        <path d="M12 16h.01" />
      </svg>
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 text-sm bg-white dark:bg-[#1D1D1D] text-gray-700 dark:text-gray-200 rounded-[8px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-normal min-w-[200px] max-w-[300px] shadow-xl z-50 border border-gray-200 dark:border-[#292929]">
        <div className="relative">
          {content}
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 translate-y-full w-2 h-2 bg-white dark:bg-[#1D1D1D] rotate-45 border-b border-r border-gray-200 dark:border-[#292929]" />
        </div>
      </div>
    </div>
  );
}; 